import { Component, Input } from '@angular/core';
import { extensionsRoute } from 'src/app/app-routing.module';
import { ExtensionDetailLinkModel } from '../models/extension-detail-link.model';

@Component({
    selector: 'ndt-extension-detail-link',
    templateUrl: './extension-detail-link.component.html',
    styleUrls: ['../detail-links.scss'],
    standalone: false
})
export class ExtensionDetailLinkComponent{
   @Input() extension: ExtensionDetailLinkModel | null;
   @Input() header: string;
   extensionsRoute = extensionsRoute;
}
